// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 65 ? "initial" : chunkId) + "." + {"65":"03bd4a0d","807":"8a16b7a4"}[chunkId] + ".chunk.css";
};